import { LineItem } from '~/commons/interfaces/models/checkout/cart/line-item/LineItem'
import { OrderLineItem } from '~/commons/interfaces/models/checkout/order/OrderLineItem'

export function getLineItemCalculatedTax<T extends LineItem | OrderLineItem>(
  lineItem: T
): number | undefined {
  return lineItem.price?.calculatedTaxes[0]?.tax
}
